import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { InputWrapper } from '@/components/Input.styles'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import TextField from '@/components/TextField'
import InputError from '@/components/InputError'
import { Spacing } from '@big-red-group/storefront-common-ui'
import 'react-datepicker/dist/react-datepicker.css'
import debounce from 'lodash.debounce'
import { VoucherEmailOptions } from '@big-red-group/storefront-common-checkout'

const VoucherEmailForm: React.FC<{
  setEmailOptions: (options: VoucherEmailOptions) => void
  setHasCompletedEmailForm: (k: boolean) => void
}> = ({ setEmailOptions, setHasCompletedEmailForm }) => {
  const [sendDate, setSendDate] = useState<Date | null>(null)
  const [showDateSelector, setShowDateSelector] = useState<boolean>(false)
  const calendarRef = useRef<any>(null)

  const dateSummary: string = useMemo(
    () =>
      sendDate
        ? sendDate.toLocaleDateString('en-us', { weekday: 'short', day: 'numeric', year: 'numeric', month: 'short' })
        : 'Send now',
    [sendDate]
  )

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('Please enter the recipient’s first name'),
    lastName: Yup.string().required('Please enter the recipient’s last name'),
  })

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      confirmEmail: '',
    },
    validationSchema,
    onSubmit: async () => {},
  })

  const handleFormChange = useCallback(
    debounce(async (options: VoucherEmailOptions) => {
      setEmailOptions({
        firstName: options.firstName,
        lastName: options.lastName,
        email: options.email,
        emailDeliveryDate: sendDate,
      })
      await formik.validateForm()
      const hasErrors = Object.keys(formik.errors).length > 0
      console.log(formik.errors)
      setHasCompletedEmailForm(!hasErrors)
    }, 100) as Function,
    [formik.errors, setEmailOptions, setHasCompletedEmailForm]
  )

  useEffect(() => {
    handleFormChange(formik.values)
  }, [formik.values, formik.errors, handleFormChange, sendDate])

  const onSelectDate = (date: Date | null) => {
    if (!date) {
      setSendDate(null)
      return
    }
    if (date.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
      setSendDate(null)
      setShowDateSelector(false)
      return
    }
    setSendDate(date)
    setShowDateSelector(false)
  }

  useEffect(() => {
    const handler = (event: MouseEvent) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target as Node)) {
        setShowDateSelector(false)
      }
    }
    document.addEventListener('mousedown', handler)
  }, [])

  return (
    <>
      <InputWrapper>
        <label className="required">Recipient first name</label>
        <TextField
          name="firstName"
          value={formik.values.firstName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="First name"
          error={!!(formik.touched.firstName && formik.errors.firstName)}
        />
        {formik.touched.firstName && formik.errors.firstName && (
          <InputError dataTestId="firstName-error-message">{formik.errors.firstName}</InputError>
        )}
      </InputWrapper>
      <Spacing size="S" />
      <InputWrapper>
        <label className="required">Recipient last name</label>
        <TextField
          name="lastName"
          value={formik.values.lastName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Last name"
          error={!!(formik.touched.lastName && formik.errors.lastName)}
        />
        {formik.touched.lastName && formik.errors.lastName && (
          <InputError dataTestId="email-error-message">{formik.errors.lastName}</InputError>
        )}
      </InputWrapper>
      <Spacing size="S" />
      {/*<InputWrapper>*/}
      {/*  <label className="required">Email (we will email the voucher to this address)</label>*/}
      {/*  <TextField*/}
      {/*    type="email"*/}
      {/*    name="email"*/}
      {/*    value={formik.values.email}*/}
      {/*    onChange={formik.handleChange}*/}
      {/*    onBlur={formik.handleBlur}*/}
      {/*    placeholder="Email"*/}
      {/*    error={!!(formik.touched.email && formik.errors.email)}*/}
      {/*  />*/}
      {/*  {formik.touched.email && formik.errors.email && (*/}
      {/*    <InputError dataTestId="email-error-message">{formik.errors.email}</InputError>*/}
      {/*  )}*/}
      {/*</InputWrapper>*/}
      <Spacing size="S" />
      <Spacing size="S" />
      {/* TODO: uncomment when email scheduling is available */}
      {/*<div>*/}
      {/*  <InputWrapper>*/}
      {/*    <label className="required">When should we send it?</label>*/}
      {/*    <TextField*/}
      {/*      name="sendDate"*/}
      {/*      value={dateSummary}*/}
      {/*      onChange={formik.handleChange}*/}
      {/*      onBlur={() => setShowDateSelector(false)}*/}
      {/*      onFocus={() => setShowDateSelector(true)}*/}
      {/*      disabled={showDateSelector}*/}
      {/*    />*/}
      {/*  </InputWrapper>*/}
      {/*  {showDateSelector && (*/}
      {/*    <CalendarWrapper ref={calendarRef}>*/}
      {/*      <DateWrapper>*/}
      {/*        <DatePickerWrapper>*/}
      {/*          <DatePicker*/}
      {/*            formatWeekDay={(nameOfDay) => nameOfDay.slice(0, 3)}*/}
      {/*            calendarContainer={Calendar}*/}
      {/*            selected={sendDate}*/}
      {/*            onSelect={(date) => onSelectDate(date)}*/}
      {/*            onChange={(date) => {}}*/}
      {/*            minDate={new Date()}*/}
      {/*            disabled={false}*/}
      {/*            dateFormat="dd-MM-yyyy"*/}
      {/*            id="datePicker"*/}
      {/*            inline*/}
      {/*            monthsShown={1}*/}
      {/*            filterDate={(date) => {*/}
      {/*              return true*/}
      {/*            }}*/}
      {/*          />*/}
      {/*        </DatePickerWrapper>*/}
      {/*      </DateWrapper>*/}
      {/*    </CalendarWrapper>*/}
      {/*  )}*/}
      {/*</div>*/}
    </>
  )
}

export default VoucherEmailForm
